module.exports = __webpack_public_path__ + "fb56b21728994fd6b18ff83122f2370c.svg";